<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="关于我们" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              北京红亚华宇科技有限公司（简称：红亚科技）成立于2012年，是一家聚焦信息技术发展，为教育从业者提供优质教育服务的创新型科技公司，面向国内本科及职业院校提供的服务包括信息安全、大数据及人工智能等专业建设服务、师资建设服务、实训基地建设服务及校企共建服务，现在全国已服务600多所高校。红亚科技始终坚持用技术改变教育方式，让教育变的更加智慧的发展理念，致力于成为国内信息技术教育服务的龙头企业。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;红亚科技创始团队全部出身教育行业，公司先后获得了国家高新技术企业、双软企业认证，并通过了ISO9001质量体系认证，AAA级信用企业，A级纳税企业、第五届北京最具文化影响企业30强认证企业、公安系统网络攻防竞赛优秀支持单位、工兵团网络攻防竞赛优秀支持单位，全国大学生大数据技能竞赛优秀支持单位，“智警杯”全国公安院校大学生大数据技能竞赛优秀支持单位。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;
              红亚科技教学产品有信息安全实验实训系统，网络安全实验实训系统，网络安全竞赛平台，网络攻防靶场平台，大数据实验实训系统，大数据科研平台，人工智能实验实训系统，大数据竞赛平台，人工智能竞赛平台及理实一体化的在线教学平台“青椒课堂”。自主研发的软件产品近30个，获得国家著作权的近50项，发明专利5项，其中3个产品被评为北京市技术创新产品。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;
              红亚科技校企合作业务包括混合所有制学院项目、大数据产业学院、网络安全产业学院、人工智能产业学院、大数据专业共建、人工智能专业共建和网络安全专业共建。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;
              红亚科技总部设在北京，为更好的服务全国用户，除北京总部外，公司还在长春、西安、南京、郑州、成都、广州、贵州、长沙、杭州、济南、沈阳、武汉、南昌等22个省会地设有办事处。
            </p>

          </div>
          <div class="summary-right">
            <img style="border-radius: 10px" class="imgbtos" src="../assets/img/hy5.jpg" alt />
          </div>
        </div>
<!--        <el-divider class="el-divider-active">-->
<!--          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>-->
<!--        </el-divider>-->
<!--        &lt;!&ndash; 发展历程 &ndash;&gt;-->
<!--        <div class="content-course">-->
<!--          <div class="top">-->
<!--            <h3>发展历程</h3>-->
<!--            <p>DEVELOPMENT</p>-->
<!--            <div class="border"></div>-->
<!--            <div class="timeline"></div>-->
<!--          </div>-->
<!--          <div class="course-time">-->
<!--            <swiper :options="swiperOption" ref="mySwiper">-->
<!--              <swiper-slide v-for="(item,index) in courseList" :key="index">-->
<!--                <div class="time-show">-->
<!--                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">-->
<!--                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>-->
<!--                    <el-divider>-->
<!--                      <i class="el-icon-mobile-phone"></i>-->
<!--                    </el-divider>-->
<!--                    <div class="item-bottom" :class="{'order' : one%2===1}">-->
<!--                      <div class="item-bottom-content">-->
<!--                        <p>{{courseOne.Content}}</p>-->
<!--                        <p>{{courseOne.Year}}</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </swiper-slide>-->
<!--              <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--              <div class="swiper-button-next" slot="button-next"></div>-->
<!--            </swiper>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="content-culture">-->
<!--          <h3>企业文化</h3>-->
<!--          <h3>CULTURE</h3>-->
<!--          <p>我们只专注一件事情——工程项目管理</p>-->
<!--          <span>确保工程无重大安全事故</span>-->
<!--          <span>确保工程施工单位无大面积返工</span>-->
<!--          <span>确保工程材料及设备无伪劣产品</span>-->
<!--          <span>确保工程管理留下痕迹、实施过程可追溯</span>-->
<!--        </div>-->
<!--        &lt;!&ndash; 公司荣誉 &ndash;&gt;-->
<!--        <div class="content-honor">-->
<!--          <div class="honor-big-img">-->
<!--            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">-->
<!--              <img v-lazy="dialogUrl" alt />-->
<!--            </el-dialog>-->
<!--          </div>-->
<!--          <div class="top">-->
<!--            <h3>公司荣誉</h3>-->
<!--            <p>HONOR</p>-->
<!--            <div class="border"></div>-->
<!--          </div>-->
<!--          <ul class="honor-show">-->
<!--            <li v-for="(honor,index) in honorList" :key="index">-->
<!--              <img-->
<!--                  v-lazy="imgserver+honor.Img"-->
<!--                  @click="dialogTableVisible = true ;dialogUrl = imgserver + honor.Img;dialogTitle= honor.Remark"-->
<!--              />-->
<!--            </li>-->
<!--          </ul>-->
<!--          <p>点击图片查看大图</p>-->
<!--        </div>-->
<!--        &lt;!&ndash; 团队风采 &ndash;&gt;-->
<!--        <div class="content-team">-->
<!--          <div class="top">-->
<!--            <h3>团队风采</h3>-->
<!--            <p>TEAM</p>-->
<!--          </div>-->
<!--          <el-carousel :interval="4000" type="card">-->
<!--            <el-carousel-item v-for="(team,index) in teamItem" :key="index">-->
<!--              <div class="swiper-img" v-lazy:background-image="imgserver + team.Img"></div>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </div>-->
<!--        &lt;!&ndash; 合作伙伴 &ndash;&gt;-->
<!--        <div class="content-partner">-->
<!--          <div class="top">-->
<!--            <h3>合作伙伴</h3>-->
<!--            <p>RARTNERS</p>-->
<!--            <ul class="partner-img">-->
<!--              <li v-for="(partner,i) in partnerImg" :key="i">-->
<!--                <img v-lazy="imgserver+partner.Img" alt />-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    this.$http
        .all([
          this.$http.get("Honor/GetHonorAll"),
          this.$http.get("Enterprise/GetEnterpriseAll"),
          this.$http.get(`Team/GetTeamAll`),
          this.$http.get(`Course/GetCourseAll`)
        ])
        .then(
            this.$http.spread(
                (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
                  this.honorList = responseHonor.data;
                  this.partnerImg = responseEnterprise.data;
                  this.teamItem = responseTeam.data;

                  var groupCount = Math.ceil(responseCourse.data.length / 2);
                  window.console.log(groupCount);
                  for (let i = 0; i < groupCount; i++) {
                    let img2 = [];
                    for (let j = 0; j < 2; j++) {
                      if (responseCourse.data.length - 1 >= i * 2 + j) {
                        img2.push(responseCourse.data[i * 2 + j]);
                      }
                    }
                    this.courseList.push(img2);
                  }
                  window.console.log(this.courseList);
                  this.loading = false;
                }
            )
        );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}



@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    transform:scale(1);
    /*开始为原始大小*/
  }
  25% {
    transform:scale(1.1);
    /*放大1.1倍*/
  }
  50% {
    transform:scale(1);
  }
  75% {
    transform:scale(1.1);
  }
}
.imgbtos {

   background-size:200px 200px;
   -webkit-animation-name:scaleDraw;
   /*关键帧名称*/
   -webkit-animation-timing-function:ease-in-out;
   /*动画的速度曲线*/
   -webkit-animation-iteration-count:infinite;
   /*动画播放的次数*/
   -webkit-animation-duration:5s;
   /*动画所花费的时间*/
 }

</style>
